// import woman from '../../../assets/images/woman.png';
import ContactButton from '../../contact-button';

export default function Solution() {
	return (
		<div className={'w-full bg-accent roboto p-8 md:px-0'}>
			<div className={'w-full flex flex-col sm:flex-row justify-center items-center'}>
				<div>
					<p className={'font-bold text-3xl sm:text-4xl text-center'}>
						Temos a solução ideal para sua indústria!
					</p>

					<div className={'w-full flex justify-center pt-4'}>
						<ContactButton color='black'/>
					</div>
				</div>
				{/*<div>*/}
				{/*	<img src={woman} alt={'Woman'} className={'hidden sm:block h-64 sm:py-0 sm:-mt-16 md:-mt-8'}/>*/}
				{/*</div>*/}
			</div>
		</div>
	);
}